<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<div
    class="tw-relative tw-flex tw-h-[380px] md:tw-h-[190px] lg:tw-h-[255px] xl:tw-h-[380px] tw-bg-[#0A0A75] sm:tw-items-center tw-items-start tw-py-4 tw-px-8 sm:tw-px-20 tw-bg-center tw-bg-cover tw-bg-no-repeat"
    style="
        background-image: url('../../../../../assets/images/contact-us/mobile.webp');
    "
>
    <div
        class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-bg-no-repeat tw-hidden sm:tw-block"
        style="
            background-image: url('../../../../../assets/images/contact-us/desktop.webp');
        "
    ></div>
    <div
        class="tw-relative tw-flex-1 tw-flex tw-flex-col tw-items-center sm:tw-items-start tw-gap-4"
    >
        <div
            class="tw-text-[32px] md:tw-text-[40px] tw-text-white tw-text-4xl tw-mt-8 sm:tw-mt-0 tw-font-bold"
        >
            {{ "SUPPORT.MAIN_TITLE" | translate }}
        </div>
    </div>
</div>

<div class="tw-py-10 tw-px-8 sm:tw-px-20">
    <div
        class="tw-text-[32px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold"
    >
        {{ "SUPPORT.REACH_US" | translate }}
    </div>
    <div class="tw-mt-4 tw-text-[#1A202C]">
        {{ "SUPPORT.REACH_US_TEXT" | translate }}
    </div>
</div>
<div
    id="contact-us"
    class="tw-flex tw-flex-col tw-gap-20 lg:tw-justify-center lg:tw-items-start lg:tw-flex-row tw-bg-[#F2F5F8] tw-py-10 tw-px-8 sm:tw-px-20"
>
    <!-- Contact Form Section -->
    <form
        class="lg:tw-w-2/3"
        id="contactUsFormId"
        [formGroup]="contactUsForm"
        (ngSubmit)="onSubmit()"
    >
        <div class="tw-w-full contact-us-form tw-flex tw-flex-col tw-gap-7">
            <div
                class="tw-text-[20px] tw-font-bold tw-text-[#003A70] tw-leading-5 lg:tw-leading-normal"
            >
                {{ "SUPPORT.FORM_TITLE" | translate }}
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
                <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8] tw-w-full">
                    <label
                        class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                    >
                        {{ "FORM.FIRST_NAME" | translate
                        }}<span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#A9ACAE]"
                        placeholder="{{ 'CONTACT_US.FIRST_NAME' | translate }}"
                        formControlName="firstName"
                        #firstName
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.firstName.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible"
                            >error_outline</mat-icon
                        >
                        <span
                            *ngIf="f.firstName.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_FIRST_NAME" | translate }}
                        </span>
                        <span
                            *ngIf="f.firstName.errors.pattern"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.FIRST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_ALPHABET_ONLY" | translate }}
                        </span>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8] tw-w-full">
                    <label
                        class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                    >
                        {{ "FORM.LAST_NAME" | translate
                        }}<span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#A9ACAE]"
                        placeholder="{{ 'CONTACT_US.LAST_NAME' | translate }}"
                        formControlName="lastName"
                        #lastName
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.lastName.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible"
                            >error_outline</mat-icon
                        >
                        <span
                            *ngIf="f.lastName.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_LAST_NAME" | translate }}
                        </span>
                        <span
                            *ngIf="f.lastName.errors.pattern"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.LAST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_ALPHABET_ONLY" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
                <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8] tw-w-full">
                    <label
                        class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                    >
                        {{ "FORM.EMAIL" | translate }}
                        <span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#A9ACAE]"
                        placeholder="abc@gmail.com"
                        formControlName="email"
                        #email
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.email.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible"
                            >error_outline</mat-icon
                        >
                        <span
                            class="tw-pt-3 tw-pb-3"
                            *ngIf="f.email.errors.required"
                        >
                            {{ "ERROR.CONTACT_US_EMAIL" | translate }}
                        </span>
                        <span
                            class="tw-pt-3 tw-pb-3"
                            *ngIf="f.email.errors.pattern"
                        >
                            {{ "ERROR.INVALID_EMAIL_ENTERED" | translate }}
                        </span>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8] tw-w-full">
                    <label
                        class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                    >
                        {{ "FORM.PHONE" | translate }}
                        <span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#A9ACAE]"
                        placeholder="+(60x) xxx xxxx"
                        formControlName="phoneNumber"
                        #phoneNumber
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.phoneNumber.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible"
                            >error_outline</mat-icon
                        >
                        <span
                            *ngIf="f.phoneNumber.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_PHONE_NO" | translate }}
                        </span>
                        <span
                            *ngIf="
                                f.phoneNumber.errors.minlength ||
                                f.phoneNumber.errors.maxlength
                            "
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.PHONE" | translate }}
                            {{
                                "ERROR.MUST_BE_MIN_6_OR_MAX_11_DIGITS"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8]">
                <label
                    class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                >
                    {{ "FORM.COMPANY" | translate }}
                    <span class="tw-text-red-400">*</span>
                </label>
                <input
                    class="tw-placeholder-[#A9ACAE]"
                    placeholder="{{ 'CONTACT_US.COMPANY_NAME' | translate }}"
                    formControlName="company"
                    #company
                    appForbiddenChars
                />
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.company.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible"
                        >error_outline</mat-icon
                    >
                    <span
                        *ngIf="f.company.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTACT_US_COMPANY_NAME" | translate }}
                    </span>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-bg-[#F2F5F8] tw-text-[16px]">
                <label
                    class="tw-text-[1rem] tw-text-[#797B7C] tw-mb-[5px] tw-font-semibold"
                >
                    {{ "FORM.MESSAGE" | translate }}
                    <span class="tw-ml-2 tw-text-gray-400">
                        {{ "FORM.MESSAGE_INFO" | translate }}
                    </span>
                    <span class="tw-text-red-400">*</span>
                </label>
                <textarea
                    class="tw-placeholder-[#A9ACAE] tw-max-[640px] tw-w-full tw-h-28 tw-bg-gray-200 tw-font-[400] tw-overflow-auto tw-pt-3.5 tw-pb-3.5"
                    placeholder="{{ 'FORM.MESSAGE_DESCRIPTION' | translate }}"
                    formControlName="message"
                    #message
                    appForbiddenChars
                >
                </textarea>
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.message.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible"
                        >error_outline</mat-icon
                    >
                    <span
                        *ngIf="f.message.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTACT_US_MESSAGE" | translate }}
                    </span>
                    <span
                        *ngIf="f.message.errors.maxlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "FORM.MESSAGE" | translate }}
                        {{ "ERROR.MUST_NOT_BE_MORE_THAN_200_CHAR" | translate }}
                    </span>
                    <span
                        *ngIf="f.message.errors.minlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTAIN_MIN_10_CHAR" | translate }}
                    </span>
                </div>
            </div>
            <div
                class="tw-flex tw-flex-wrap lg:tw-flex-nowrap tw-gap-5 tw-items-center tw-justify-start md:tw-justify-center"
            >
                <div
                    class="tw-order-2 md:tw-order-1 tw-text-left tw-text-sm md:tw-text-base tw-text-[#797B7C]"
                >
                    {{ "SUPPORT.SUPPORT_SUBMIT_MESSAGE" | translate }}

                    <br class="tw-hidden md:tw-block" />

                    <span *ngIf="selectedLanguage == 'bm'">
                        {{ "SUPPORT.SUBMIT_MESSAGE$" | translate }}
                    </span>

                    <span *ngIf="selectedLanguage == 'bm'">
                        <a
                            class="tw-underline"
                            href="/assets/documents/Polisi Privasi(BM).pdf"
                            alt="Image description"
                            target="_blank"
                        >
                            {{ "COMMON.PRIVACY_NOTICE" | translate }}</a
                        >
                        dan
                        <a
                            class="tw-underline"
                            href="/assets/documents/Terma Penggunaan(BM).pdf"
                            alt="Image description"
                            target="_blank"
                        >
                            {{ "FOOTER.TERMS_OF_USE" | translate }}</a
                        >
                        kami.
                    </span>
                    <span *ngIf="selectedLanguage == 'en'">
                        <a
                            class="tw-underline"
                            href="/assets/documents/Privacy & Security Policies.pdf"
                            alt="Image description"
                            target="_blank"
                            >{{ "FOOTER.PRIVACY_POLICY" | translate }}</a
                        >
                        and
                        <a
                            class="tw-underline"
                            href="/assets/documents/Terms of Use (EN).pdf"
                            alt="Image description"
                            target="_blank"
                            >{{ "FOOTER.TERMS_OF_USE" | translate }}</a
                        >.
                    </span>
                </div>
                <button
                    ga-event-id="send_message_button_contact_us_click"
                    ga-event-category="Contact Us Button"
                    ga-event-label="Send Message Main Button Click"
                    ga-track="track"
                    class="tw-font-[500] tw-text-[1.1rem] tw-order-1 md:tw-order-2 tw-text-white tw-text-cm tw-bg-[#FFA64D] tw-p-3 tw-from-[#FFA53C] tw-to-[#FFC53C] tw-py-[0.9rem] tw-basis[50%] tw-whitespace-nowrap tw-rounded-[3rem] tw-px-[2.2rem] 2xl:tw-px-[2.5rem] tw-ml-0 md:tw-ml-auto"
                    type="submit"
                    [disabled]="disableSubmitBtn"
                >
                    {{ "COMMON.SUBMIT" | translate }}
                </button>
            </div>
        </div>
    </form>
</div>

<app-footer></app-footer>
